import { ref } from "vue";

export type NotificationKind = "success" | "error" | "warning" | "info";

export interface Notification {
  uid: number;
  text: string;
  kind: NotificationKind;
}

const notificationList = ref<Notification[]>([]);
let counter = 0;

function pushNotification(
  text: string,
  kind: NotificationKind = "error",
  timeout = 3000
) {
  const uid = counter++;

  if (notificationList.value.length >= 3) {
    notificationList.value.splice(0, 1);
  }

  notificationList.value.push({ uid, text, kind });

  setTimeout(() => {
    deleteNotification(uid);
  }, timeout);
}

function deleteNotification(uid: number) {
  notificationList.value = notificationList.value.filter(
    (item) => item.uid !== uid
  );
}

export function useNotification() {
  return {
    notificationList,
    pushNotification,
    deleteNotification,
  };
}
